import React from 'react'
import { Container, Stack, Text, Icon } from '@popety-io/ui'
import { PublicLayout } from '../components/PublicLayout'
import {
  PageWrapper,
  HeroSection,
  FeatureCard,
  InfoCard,
} from './HomePage.styles'

const HomePage: React.FC = () => {
  return (
    <PublicLayout>
      <Container>
        <PageWrapper>
          <Stack spacing="xl">
            {/* Hero Section */}
            <HeroSection>
              <Stack align="center" spacing="lg">
                <Icon name="home" size="xl" color="primary" />
                <Stack spacing="md">
                  <Text variant="h1" weight="bold">
                    Popety Public Portal
                  </Text>
                  <Text variant="h3" color="secondary">
                    Access shared real estate analysis and reports
                  </Text>
                </Stack>
              </Stack>
            </HeroSection>

            {/* Features Section */}
            <FeatureCard>
              <Stack align="center" spacing="lg">
                <Icon name="calculator" size="xl" color="primary" />
                <Stack spacing="md">
                  <Text variant="h3" weight="bold">
                    Property Estimates
                  </Text>
                  <Text variant="body1" color="secondary">
                    Access comprehensive property valuations and market
                    estimates through secure, shareable links
                  </Text>
                </Stack>
              </Stack>
            </FeatureCard>

            {/* Info Section */}
            <InfoCard>
              <Stack spacing="md">
                <Text variant="h4" weight="bold">
                  Access Your Shared Estimate
                </Text>
                <Text variant="body1" color="secondary">
                  If you have a shared estimate link, use the specific URL
                  provided to access your property valuation. Each estimate is
                  uniquely identified and secured with a hash-based link.
                </Text>
              </Stack>
            </InfoCard>
          </Stack>
        </PageWrapper>
      </Container>
    </PublicLayout>
  )
}

export default HomePage
